import axios from 'axios';
import {
  environmentConfigSelector,
  storeIdentifierNameSelector,
  storeIdSelector,
} from 'store/selectors/commonSelector';
import { setPromotionData } from 'store/slices/quickView';
import { useAppDispatch, useAppSelector } from 'store/store';

const usePromotionData = (catentryId) => {
  const storeId = useAppSelector(storeIdSelector);
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const environmentConfig = useAppSelector(environmentConfigSelector);
  const dispatch = useAppDispatch();

  const { baseUrl, key, headerEnvValue } =
    environmentConfig.api.promotionData[storeIdentifierName] ||
    environmentConfig.api.promotionData.dsg;

  const fetchPromotionData = async () => {
    if (!catentryId) return;

    dispatch(setPromotionData(null));

    if (typeof document !== 'undefined') {
      const previewTime = document.getElementById('strPreviewTime')
        ? document.getElementById('strPreviewTime').value
        : '';
      const channelId = document.getElementById('channelId')
        ? document.getElementById('channelId').value
        : '-1';
      const requestURL = `${baseUrl}/${storeId}?catentryIds=[${catentryId}]&previewTime=${previewTime}&channelId=${channelId}`;

      try {
        const response = await axios(requestURL, {
          method: 'GET',
          headers: {
            Env: headerEnvValue,
            'x-CentraSite-APIKey': key,
          },
        });

        const promoDetails = response?.data?.data?.promoDetailsMap ?? null;

        dispatch(setPromotionData(promoDetails));
      } catch (error) {
        console.error(`Request failed for promotion API: ${error.message}`);
      }
    }
  };

  return [fetchPromotionData];
};

export default usePromotionData;
